export default __webpack_public_path__ + "static/media/DollarSecondary.a446da56.svg";